import { CompactComposer } from "@design";
import { ArrowUp, Sparkle } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { newSpaceChatPath, withPrompt } from "../spaceChat";

/**
 * "Ask about this space": opens a new chat in the space with the question sent. With the
 * knowledge graph on, that chat uses the space's wiki as background context (system prompt).
 */
export function SpaceAsk({ spaceUuid, isPersonal }: Readonly<{ spaceUuid: string; isPersonal: boolean }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "detail.ask" });
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const send = () => {
    if (!value.trim()) return;
    navigate(newSpaceChatPath(spaceUuid), { state: withPrompt(value) });
  };
  return (
    <CompactComposer
      aria-label={t("label")}
      placeholder={t(isPersonal ? "privatePlaceholder" : "placeholder")}
      leadingIcon={<Sparkle />}
      sendIcon={<ArrowUp />}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onSend={send}
      sendDisabled={value.trim().length === 0}
    />
  );
}
